import React,{useEffect}  from "react";
import Swal from "sweetalert2";
import "./slider/slider.css"; 
import Header from "../../components/header/Header"; 
import ExtraOffer from "../../components/extraOffer/ExtraOffer";
import Slider from "./slider/Slider"
import FeatureCategory  from "../../components/featureCategory/FeatureCategory";
import PopularProducts from "../../components/popularProducts/PopularProducts";
import BannerThree from "../../components/bannerThree/BannerThree";

import DailyBestSells from "../../components/dailyBestSells/DailyBestSells";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
  import imgh from "../../assets/images/advertise_popup_img.jpg"
function Home(){
    useEffect(() => {
        console.log("Home page loaded.");
      }, []);
       useEffect(() => {
    console.log("Home page loaded.");

    //  Show advertisement popup on page load
    Swal.fire({
      title: "Special Offer!",
      text: "🛍️ Buy One, Get One FREE! 🎁 🚀",
    // imageUrl: "./assets/images/advertise_popup_img.jpg",
      imageUrl: imgh,
      imageWidth: 450,
      imageHeight: 300,
      imageAlt: "Advertisement",
      confirmButtonText: "Shop Now",
      confirmButtonColor: "#ff5722",
      backdrop: true,
      timer: 8000,
      timerProgressBar: true,
    });
  }, []);

    return(
        <>
          <Header />
          <Slider />
          <FeatureCategory />
          <BannerThree />
          <PopularProducts />
          <ExtraOffer />
          <DailyBestSells />
           <Subscribe /> 
           <Footer />

        </>
    )
}

export default Home;







